import styled from "styled-components";

export const MainContainer = styled.div`
  overflow: hidden;
  margin-top: -60px;
  position: relative;

  img {
    height: 100vh;
    width: auto;
    min-width: 100%;
    background-color: rgba(0, 0, 0, 0.85) !important;

    @media (max-width: 768px) {
      height: 65vh;
    }
  }
  .slick-prev {
    left: -52px !important;
  }
  .slick-next {
    left: -52px !important;
  }

  .slick-next:before,
  .slick-prev:before {
    /* content: "" !important; */
  }
  .next-slick-arrow,
  .prev-slick-arrow {
    color: #000000;
    font-size: 48px;
  }
  .thumbnail-slider-wrap {
    margin-top: 15px;
    height: 85px;
  }
  .thumbnail-slider-wrap .slick-track .slick-slide {
    text-align: center;
  }
  .thumbnail-slider-wrap .slick-track .slick-slide img {
    width: 70%;
  }
  .titleContainer {
    position: absolute;
    /* padding-top: 150px; */
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
    flex-direction: column;
    padding-right: 140px;
    padding-left: 140px;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
    @media (max-width: 768px) {
      padding-right: unset;
      padding-left: unset;
      /* padding-top: 65px; */
    }
  }
  .slick-slide {
    position: relative;
  }
  .slick-dots.slick-thumb > li > a > img {
    width: 143px;
    border: 2px solid #ffffff;
    border-radius: 5px;

    /* height: 43px; */
  }
  .slick-dots.slick-thumb {
    display: flex !important;
    flex-direction: row;
    gap: 160px;
    justify-content: center;
    bottom: 100px;
  }
  .slick-list {
    height: 101.75vh;

    @media (max-width: 768px) {
      height: fit-content !important;
    }
  }
  .slick-dots.slick-thumb > li > a > img {
    width: 143px;
    height: 96.66px !important;
  }
  .slick-dots.slick-thumb {
  }
  @media (max-width: 768px) {
    .slick-dots.slick-thumb > li > a > img {
      width: 75.66px;
      height: 75.66px !important;
    }
    .slick-dots.slick-thumb {
      bottom: 65px;
      display: block;
      gap: 60px;
      right: 35px;
      gap: 60 !important;
    }
  }
`;

export const Description = styled.p`
  font-size: 20px;
  font-family: Poppins-Light;
  color: #ffffff;
  text-align: center;
  letter-spacing: 1px;
  @media (max-width: 768px) {
    font-size: 12px;
    padding-right: 40px;
    padding-left: 40px;
  }
`;

export const Heading = styled.h1`
  font-size: 75px !important;
  font-family: BebasNeue-Regular;
  color: #ffffff;
  text-align: center;
  margin: unset;
  letter-spacing: 5px;
  span {
    color: #fcecb4;
  }
  @media (max-width: 768px) {
    font-size: 34px !important;
    /* margin: auto; */
  }
`;

export const Colored = styled.h1`
  font-size: 81px;
  font-family: "BebasNeue-Regular";
  color: #fcecb4;
  text-align: center;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Button = styled.button`
  /* font-size: 18px;
  font-family: Poppins-Light; */
  width: 170px;
  height: 60px;
  background: #0f1a20 0% 0% no-repeat padding-box;
  border: 1px solid #ffffff;
  border-radius: 8px;
  opacity: 65%;
  cursor: pointer;
  align-self: center;
  color: #ffffff;
  :hover {
    background: #fcecb4 0% 0% no-repeat padding-box;
    color: #1d1d1d;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    height: 45px;
    width: 130px;
  }
`;
